import {
  NOT_GOOD_ILLUSTRATION,
  REVIEW_ILLUSTRATION,
  REVIEW_PANEL_GRADIENT_BG,
  THANKYOU_ILLUSTRATION,
} from '../copy';

export type ReviewVisualKey =
  | 'entry'
  | 'trustpilot'
  | 'feedback'
  | 'feedbackNotGood'
  | 'thankyou';

const REVIEW_VISUAL_SOURCES: Record<ReviewVisualKey, string[]> = {
  entry: [REVIEW_PANEL_GRADIENT_BG, REVIEW_ILLUSTRATION.entry.src],
  trustpilot: [
    REVIEW_PANEL_GRADIENT_BG,
    REVIEW_ILLUSTRATION.trustpilot.src,
    THANKYOU_ILLUSTRATION.heart,
    THANKYOU_ILLUSTRATION.smile,
  ],
  feedback: [REVIEW_PANEL_GRADIENT_BG, REVIEW_ILLUSTRATION.feedback.src],
  feedbackNotGood: [REVIEW_PANEL_GRADIENT_BG, NOT_GOOD_ILLUSTRATION.faces],
  thankyou: [
    REVIEW_PANEL_GRADIENT_BG,
    THANKYOU_ILLUSTRATION.heart,
    THANKYOU_ILLUSTRATION.smile,
  ],
};

const imageLoadCache = new Map<string, Promise<void>>();

function preloadImage(src: string): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();

  const cached = imageLoadCache.get(src);
  if (cached) return cached;

  const promise = new Promise<void>((resolve) => {
    const img = new Image();
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;

      if (typeof img.decode === 'function') {
        void img.decode().catch(() => {}).finally(resolve);
        return;
      }

      resolve();
    };

    img.onload = finish;
    img.onerror = finish;
    img.decoding = 'async';
    img.src = src;

    if (img.complete) finish();
  });

  imageLoadCache.set(src, promise);

  return promise;
}

export function warmReviewFlowVisuals(keys: ReviewVisualKey[]): void {
  const sources = new Set<string>();

  keys.forEach((key) => {
    REVIEW_VISUAL_SOURCES[key].forEach((src) => sources.add(src));
  });

  sources.forEach((src) => {
    void preloadImage(src);
  });
}

export async function ensureReviewFlowVisualReady(
  key: ReviewVisualKey
): Promise<void> {
  await Promise.all(REVIEW_VISUAL_SOURCES[key].map(preloadImage));
}
